import { baseApi } from './baseApi';

export const mediaApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadRichTextMedia: builder.mutation({
      query: (formData) => ({
        url: '/media/richtext/upload',
        method: 'POST',
        body: formData,
      }),
      // Add appropriate tag types if needed for cache invalidation
      invalidatesTags: ['Exercise', 'ExerciseQuestion'],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useUploadRichTextMediaMutation,
} = mediaApi;

export default mediaApi;